
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';
import { FormaDePagamento } from '@app/models/forma-de-pagamento.model';

@Injectable()
export class FormaDePagamentoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(conta: FormaDePagamento): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/formadepagamento', conta).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  // alterar(conta: FormaDePagamento) {
  //   return this.http.put(this.URL_API + "formadepagamento", conta)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/formadepagamento/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/formadepagamento/${id}`);
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + `formadepagamento`)
  //     .map((res: Response) => res.json());
  // }

  // obterTodosPorTipo(tipoCreditoDebito : string) {
  //   return this.http.get(this.URL_API + `formadepagamento/ObterTodosPorTipo?tipo=${tipoCreditoDebito}`)
  //     .map((res: Response) => res.json());
  // }


  obteLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/formadepagamento/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
